import { combineReducers } from '@reduxjs/toolkit';

import { carePlansApi } from '~clients/actions/carePlans';

import clientSupportPlanRevisions from './clientSupportPlanRevisions';
import clientSupportPlans from './clientSupportPlans';

export const clients = {
  clientSupportPlans,
  clientSupportPlanRevisions,
};

export default combineReducers(clients);

export const clientApis = [carePlansApi] as const;
